import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    MainWrapper: {
      minHeight: '100vh',
      position: 'relative',
      paddingBottom: '60px',
      boxSizing: 'border-box'
    },
    FooterConponent: {
      position: 'absolute',
      bottom: 0,
      width: '100%'
    }
  })
);
